import React, { useState, useEffect } from 'react';
import '../css/AutoComplete.css'

export default function InputPhone({ value='', parameters}) {

    const [valueInput, setValueInput] = useState(value);

    function mascaraTelefone(e) {
        let valor = e.target.value;
    
        // Remove tudo que não for número
        valor = valor.replace(/\D/g, "");
    
        // Limita a 11 dígitos (corrige erro de números com mais de 11 dígitos)
        valor = valor.slice(0, 11);
    
        // Aplica a máscara dinamicamente
        if (valor.length > 10) {
            // Celular (11 dígitos)
            valor = valor.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
        } else if (valor.length > 6) {
            // Fixo (10 dígitos)
            valor = valor.replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
        } else if (valor.length >= 2) {
            // Apenas DDD preenchido
            valor = valor.replace(/^(\d{2})(\d{0,5})/, "($1) $2");
        }
    
        return valor;
    }
    

    return (
        <div className="input-group" style={{"width": parameters.width || '30%'}} >
            <input id={parameters.id} 
                // placeholder="(00) 00000-0000"
                onInput={(e) => mascaraTelefone(e)}
                type={parameters.type || "text"}  
                value={value || ''}
                style={parameters.error ? {"borderBottom": "2px solid red"}: {}}
                onChange={(e) => {
                    const value = mascaraTelefone(e);
                    setValueInput(value)
                    parameters.onChange(value)
                }}
                required={parameters.required}/>
            
            <label htmlFor={parameters.id} >{parameters.label}</label>
        </div>
    );
}

